// import moment from 'moment';

export const updateState = (oldObject, updatedProperties) => ({ ...oldObject, ...updatedProperties });

export const checkLength = (string, length) => string.length >= length;
export const isEmail = (email) => {
  // email regex
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(String(email).toLowerCase());
};

// export const getDateTime = date => moment.unix(date).format('DD/MM/YYYY HH:mm');
// export const getMomentDate = date => moment.unix(date);

export const getSelectedTab = (tab) => {
  if (tab === '/add-event') {
    return 0;
  }
  if (tab === '/edit-event') {
    return 1;
  }
  if (tab === '/events') {
    return 2;
  }
  if (tab === '/users') {
    return 3;
  }
  return 0;
};

export const getPriceByDiscount = (price, discount) => {
  const discountPart = ((discount * price) / 100).toFixed(0);
  return price - discountPart;
};

export const insertAt = (str, sub, pos) => `${str.slice(0, pos)}${sub}${str.slice(pos)}`;
export const getDotPosition = (string) => string.indexOf('.');
